export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/a57ede53-f877-4f07-a750-dd803af3b2e6/images/ef25e15341275563d199ef868b9983dfdbbb9dd57182d614c56dfa5a6c8099b1.jpeg",
  totesStack: "https://static.prod-images.emergentagent.com/jobs/a57ede53-f877-4f07-a750-dd803af3b2e6/images/66d3e84fa19be7400ee8956187c41195dd7ea1b2cf07e69d41822bbb829bd64c.jpeg",
  familyMoving: "https://static.prod-images.emergentagent.com/jobs/a57ede53-f877-4f07-a750-dd803af3b2e6/images/d4a157340666c94d5de3e6bb0c0b324323b68c72b9d0481f8b45f7469ccfc8d3.jpeg",
  deliveryVan: "https://static.prod-images.emergentagent.com/jobs/a57ede53-f877-4f07-a750-dd803af3b2e6/images/f70fd38894b389b08e21432bd692c74d812e413adf74dcb1f52cb0db3b554faa.jpeg",
};

export const CONTACT = {
  phone: "(712) 728-7191",
  phoneHref: "tel:+17127287191",
  email: "info.colorcratemoving@gmail.com",
  facebook: "https://www.facebook.com/share/1DBFiEww8p/?mibextid=wwXIfr",
  hours: [
    { day: "Monday – Friday", time: "8:00 AM – 6:00 PM" },
    { day: "Saturday", time: "9:00 AM – 4:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
};

export const STEPS = [
  { n: "01", title: "Reserve Online", desc: "Pick your package and moving dates in minutes. No deposit hassle, no store trips." },
  { n: "02", title: "We Deliver", desc: "We drop off clean, sturdy totes right at your door — stacked and ready to pack." },
  { n: "03", title: "Pack & Move", desc: "Load up your color-coded crates. No tape, no folding, no collapsing boxes." },
  { n: "04", title: "We Pick Them Up", desc: "When you're unpacked, we swing by and haul them away. Zero cleanup for you." },
];

export const FEATURES = [
  { icon: "Recycle", title: "Reusable Plastic Totes", desc: "Built to be used hundreds of times — a smarter alternative to single-use cardboard.", span: "lg:col-span-2" },
  { icon: "Ban", title: "No Tape Required", desc: "Snap-on lids. Done.", span: "" },
  { icon: "CloudRain", title: "Weather Resistant", desc: "Rain or shine, your belongings stay dry and protected.", span: "" },
  { icon: "Layers", title: "Perfectly Stackable", desc: "Uniform crates stack tight and travel safely — no crushed boxes.", span: "lg:col-span-2" },
  { icon: "Feather", title: "Easy To Carry", desc: "Ergonomic handles for a comfortable grip.", span: "" },
  { icon: "Leaf", title: "Eco-Friendly", desc: "Cut the cardboard waste. Move green.", span: "" },
  { icon: "Truck", title: "Delivered To You", desc: "Straight to your doorstep on your schedule.", span: "" },
  { icon: "PackageCheck", title: "Picked Up When Finished", desc: "We collect them when you're done. Simple.", span: "lg:col-span-2" },
];

export const PACKAGES = [
  {
    name: "Apartment",
    totes: "25 Totes",
    price: "89",
    period: "1 Week Rental",
    desc: "Perfect for studios & one-bedroom apartments.",
    features: ["25 reusable totes", "1 week rental", "Free delivery", "Free pickup", "4 moving labels"],
    featured: false,
  },
  {
    name: "Home",
    totes: "45 Totes",
    price: "149",
    period: "2 Week Rental",
    desc: "Ideal for 2–3 bedroom homes.",
    features: ["45 reusable totes", "2 week rental", "Free delivery", "Free pickup", "2 moving dollies", "8 moving labels"],
    featured: false,
  },
  {
    name: "Large Home",
    totes: "75 Totes",
    price: "229",
    period: "3 Week Rental",
    desc: "Made for 4+ bedroom homes.",
    features: ["75 reusable totes", "3 week rental", "Priority delivery", "Free pickup", "4 moving dollies", "Wardrobe totes", "16 moving labels"],
    featured: true,
  },
  {
    name: "Custom",
    totes: "You Choose",
    price: "Quote",
    period: "Flexible",
    desc: "For businesses & unique moves.",
    features: ["Any number of totes", "Flexible rental period", "Scheduled delivery", "Scheduled pickup", "Dedicated support"],
    featured: false,
  },
];

export const ADDONS = [
  { name: "Moving Dolly", price: "$12 / week" },
  { name: "Wardrobe Tote", price: "$8 / week" },
  { name: "Extra Totes (per 5)", price: "$15 / week" },
  { name: "Packing Labels (set)", price: "$5" },
  { name: "Extended Rental (per week)", price: "$20" },
];

export const AREAS = [
  { name: "Clarinda", x: 46, y: 62 },
  { name: "Shenandoah", x: 30, y: 70 },
  { name: "Red Oak", x: 40, y: 44 },
  { name: "Essex", x: 34, y: 55 },
  { name: "Sidney", x: 20, y: 78 },
];

export const REVIEWS = [
  { name: "Jessica M.", role: "First-time home buyer", stars: 5, text: "Color Crate made our move so much less stressful. The totes showed up clean and stacked, and pickup was a breeze. We'll never go back to cardboard." },
  { name: "Marcus & Dana", role: "Family of five", stars: 5, text: "Packing by color kept our whole family organized. The kids even helped! Everything arrived at the new house intact." },
  { name: "Sarah T.", role: "Apartment renter", stars: 5, text: "As a renter who moves often, this is a game changer. No more hunting for boxes at the grocery store. Booked online in five minutes." },
  { name: "Realtor — Beth K.", role: "Local Realtor", stars: 5, text: "I recommend Color Crate to every client. It's a professional, eco-friendly touch that makes closings smoother." },
  { name: "Gene R.", role: "Downsizing senior", stars: 5, text: "The handles made everything easy to carry, and the team was so kind and patient. Truly a stress-free experience." },
];

export const FAQS = [
  { q: "How long is a rental?", a: "Rental periods start at one week and scale with your package — up to three weeks on our Large Home plan. Need longer? Just add extended rental weeks at checkout or choose a Custom package." },
  { q: "Do you deliver?", a: "Yes! Free delivery and pickup are included in every package throughout our Southwest Iowa service area. We bring the totes right to your door, stacked and ready to pack." },
  { q: "What if I need more totes?", a: "No problem. You can add extra totes to any package during reservation, or contact us mid-move and we'll drop off more. You only pay for what you use." },
  { q: "How many totes do I need?", a: "A studio or 1-bedroom typically needs ~25 totes, a 2–3 bedroom home ~45, and a 4+ bedroom home ~75. Not sure? Reach out and we'll help you estimate." },
  { q: "How does pickup work?", a: "Once you've unpacked, schedule a pickup online or give us a call. We'll come collect the empty totes at your convenience — no cleaning or breaking down required." },
  { q: "Are the totes clean?", a: "Absolutely. Every crate is sanitized between rentals so your belongings go into a fresh, clean tote every time." },
];

export const PACKAGE_OPTIONS = ["Apartment Package", "Home Package", "Large Home Package", "Custom Package"];
